const ACTIVITY_CATEGORY_PREFIX = 'ACTIVITY_CATEGORY_';
const UNDEFINED_ACTIVITY_CATEGORY = 'ACTIVITY_CATEGORY_UNDEFINED';

/**
 * Asked for as the `defaultValue` so a category the locale files don't cover
 * yet is recognisable: i18next echoes the lookup key back otherwise, which
 * would render `share.activityCategory.*` as a visible tag.
 */
const MISSING_TRANSLATION = ' missingActivityCategory';

export type ActivityCategoryTranslator = (
  key: string,
  options?: { defaultValue?: string }
) => string;

export const getActivityCategoryTranslationKey = (category: string) => {
  const translationKey = category.startsWith(ACTIVITY_CATEGORY_PREFIX)
    ? category.slice(ACTIVITY_CATEGORY_PREFIX.length)
    : category;

  return `share.activityCategory.${translationKey}`;
};

export const getActivityCategoryTags = (
  categories: readonly string[] | null | undefined,
  translate: ActivityCategoryTranslator
) =>
  categories
    ?.filter(category => category !== UNDEFINED_ACTIVITY_CATEGORY)
    .map(category =>
      translate(getActivityCategoryTranslationKey(category), {
        defaultValue: MISSING_TRANSLATION
      })
    )
    // The API can ship a new category before the locale files catch up; skip
    // those rather than showing a raw translation key.
    .filter(tag => tag !== MISSING_TRANSLATION) ?? [];
